const enum InputVariant {
  default = 'default',
  iconLeading = 'iconLeading',
}

export default InputVariant
